import loadable from '@loadable/component';

export const GolfmonthlySiteWrapper = loadable(
  () => import(/* webpackChunkName: "golfmonthly-site" */ './GolfmonthlySiteWrapper'),
);
